import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from '../../../assets/icons/back.svg';
import { API } from '../../../config/API';
import { useTheme } from '../../../hooks/useTheme';
import { paths } from '../../../Router/paths';
export const BackButton = () => {
    const theme = useTheme();
    return (
        <Link
            to={paths.HOME(API.getMenuId())}
            className="p-0 w-10 h-10 bg-white text-brand-iconColor rounded-full flex justify-center items-center"
        >
            <BackIcon className="fill-current" style={{ fill: theme.primaryColor }} />
        </Link>
    );
};
